import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArrowUpLeftComponent } from "./med-icon-arrow-up-left.component";

@NgModule({
  declarations: [
    MedIconArrowUpLeftComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArrowUpLeftComponent,
  ],
})
export class MedIconArrowUpLeftModule { }
